import { useCallback } from 'react';
import { markCreditEventNotificationSeen } from './credit-events-local-storage';

export function useCreditEventsSeenStorage() {
  const markNotificationSeen = useCallback((notificationId: string) => {
    markCreditEventNotificationSeen(notificationId);
  }, []);

  return { markNotificationSeen };
}
